import { PecaDetalhe3D } from './PecaDetalhe3D'

export function SegmentoHumano3D({
  comprimento,
  raio,
  cor,
}: {
  comprimento: number
  raio: number
  cor: string
}) {
  return (
    <mesh position={[0, -comprimento / 2, 0]} castShadow>
      <capsuleGeometry args={[raio, comprimento - raio * 2, 4, 10]} />
      <meshStandardMaterial color={cor} roughness={0.78} />
    </mesh>
  )
}

function ArticulacaoHumana3D({ raio, cor }: { raio: number; cor: string }) {
  return (
    <mesh castShadow>
      <sphereGeometry args={[raio, 10, 8]} />
      <meshStandardMaterial color={cor} roughness={0.8} />
    </mesh>
  )
}

export function CorpoHumano3D({
  cor,
  corCalca = cor,
  civil = false,
  corLuvas,
}: {
  cor: string
  corCalca?: string
  civil?: boolean
  corLuvas?: string
}) {
  const mao = corLuvas ?? (civil ? '#d7ad8e' : '#242c30')
  return (
    <group name="corpo-humano">
      <PecaDetalhe3D
        posicao={[0, 1.17, 0]}
        tamanho={[0.43, 0.58, 0.28]}
        cor={cor}
        raio={0.085}
        rugosidade={0.8}
      />
      <PecaDetalhe3D
        posicao={[0, 0.87, 0]}
        tamanho={[0.36, 0.2, 0.27]}
        cor={corCalca}
        raio={0.065}
        rugosidade={0.85}
      />
      {[-1, 1].map((lado) => (
        <group key={lado}>
          <group
            position={[lado * 0.105, 0.88, 0]}
            rotation={[0, 0, lado * 0.035]}
          >
            <SegmentoHumano3D comprimento={0.4} raio={0.092} cor={corCalca} />
            <group position={[0, -0.4, 0]} rotation={[civil ? 0.06 : 0, 0, 0]}>
              <ArticulacaoHumana3D raio={0.07} cor={corCalca} />
              <SegmentoHumano3D
                comprimento={0.36}
                raio={0.073}
                cor={corCalca}
              />
              <PecaDetalhe3D
                posicao={[0, -0.4, 0.045]}
                tamanho={[0.16, 0.13, 0.27]}
                cor={civil ? '#465262' : '#20272c'}
                raio={0.035}
                rugosidade={0.9}
              />
              <PecaDetalhe3D
                posicao={[0, -0.45, 0.045]}
                tamanho={[0.165, 0.03, 0.275]}
                cor="#141b22"
                raio={0.01}
                rugosidade={1}
              />
            </group>
          </group>
          <group
            position={[lado * 0.26, 1.39, 0]}
            rotation={[-0.08, 0, lado * (civil ? 0.18 : 0.1)]}
          >
            <ArticulacaoHumana3D raio={0.075} cor={cor} />
            <SegmentoHumano3D comprimento={0.27} raio={0.07} cor={cor} />
            <group position={[0, -0.27, 0]} rotation={[-0.12, 0, 0]}>
              <ArticulacaoHumana3D raio={0.054} cor={civil ? mao : cor} />
              <SegmentoHumano3D
                comprimento={0.26}
                raio={0.057}
                cor={civil ? mao : cor}
              />
              <PecaDetalhe3D
                posicao={[0, -0.29, 0]}
                tamanho={[0.085, 0.12, 0.07]}
                cor={mao}
                raio={0.025}
              />
              <PecaDetalhe3D
                posicao={[lado * -0.05, -0.26, 0.025]}
                tamanho={[0.035, 0.065, 0.04]}
                cor={mao}
                raio={0.015}
                rotacao={[0, 0, lado * -0.35]}
              />
              {!civil && (
                <PecaDetalhe3D
                  posicao={[0, -0.205, 0]}
                  tamanho={[0.125, 0.055, 0.125]}
                  cor="#394548"
                  raio={0.025}
                />
              )}
            </group>
          </group>
        </group>
      ))}
    </group>
  )
}

export function CabecaHumana3D({ cabelo = false }: { cabelo?: boolean }) {
  return (
    <group name="cabeca-humana">
      <mesh position={[0, 1.49, 0]} castShadow>
        <cylinderGeometry args={[0.055, 0.06, 0.12, 10]} />
        <meshStandardMaterial color="#d7ad8e" roughness={0.8} />
      </mesh>
      <mesh position={[0, 1.65, 0]} scale={[0.86, 1.1, 0.9]} castShadow>
        <sphereGeometry args={[0.13, 16, 12]} />
        <meshStandardMaterial color="#d7ad8e" roughness={0.75} />
      </mesh>
      {[-1, 1].map((lado) => (
        <group key={lado}>
          <mesh position={[lado * 0.113, 1.64, 0]} scale={[0.5, 1, 0.65]}>
            <sphereGeometry args={[0.025, 8, 6]} />
            <meshStandardMaterial color="#c5967b" />
          </mesh>
          <PecaDetalhe3D
            posicao={[lado * 0.04, 1.66, 0.113]}
            tamanho={[0.033, 0.008, 0.012]}
            cor="#403632"
            raio={0.003}
          />
        </group>
      ))}
      <PecaDetalhe3D
        posicao={[0, 1.635, 0.12]}
        tamanho={[0.025, 0.04, 0.035]}
        cor="#c5967b"
        raio={0.01}
      />
      <PecaDetalhe3D
        posicao={[0, 1.6, 0.109]}
        tamanho={[0.035, 0.006, 0.009]}
        cor="#996959"
        raio={0.002}
      />
      {cabelo && (
        <mesh
          position={[0, 1.65, -0.008]}
          scale={[0.88, 1.12, 0.92]}
          castShadow
        >
          <sphereGeometry
            args={[0.132, 16, 10, 0, Math.PI * 2, 0, Math.PI * 0.46]}
          />
          <meshStandardMaterial color="#49382e" roughness={0.95} />
        </mesh>
      )}
    </group>
  )
}
